import moment from 'moment'
import React from 'react'
import styled from 'styled-components'
import { HydratedUserInfo } from '../types'

const IDCard = styled.div`
  background: #eef0f3;
  border-radius: 20px;
  display: flex;
  padding: 16px;
  gap: 24px;
`

const Avatar = styled.img`
  height: 50px;
  width: 50px;
`

const IDInfo = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
`

const RegistrationInfo = styled.div`
  display: flex;
  gap: 24px;
`

interface Props
  extends Pick<
    HydratedUserInfo,
    'username' | 'sub' | 'enabled' | 'registeredDate' | 'lastModifiedDate'
  > {}

export const UserInfoSection: React.FC<Props> = ({
  username,
  sub,
  enabled,
  registeredDate,
  lastModifiedDate,
}) => {
  return (
    <IDCard data-testid="id-card">
      <Avatar src="/images/icon-avatar.svg" alt="avatar icon" />
      <IDInfo>
        <p>
          <b>Platform Username:</b> {username}
        </p>
        <p>
          <b>Platform Subject:</b> {sub}
        </p>
        <p>
          <b>Enabled:</b> {enabled.toString()}
        </p>
        <RegistrationInfo>
          <p>
            <b>Registered At:</b> {moment(registeredDate).format('lll')}
          </p>
          <p>
            <b>Updated At:</b> {moment(lastModifiedDate).format('lll')}
          </p>
        </RegistrationInfo>
      </IDInfo>
    </IDCard>
  )
}
